import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCashback = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 2h9a5 5 0 0 1 3.506 8.565c-.305.3-.73.432-1.158.435h-6.027l3.043-3.043a1 1 0 0 0-1.414-1.414l-4.701 4.7a1 1 0 0 0-.218 1.088.997.997 0 0 0 .222.336l4.697 4.697a1 1 0 0 0 1.414-1.414L11.414 13h5.919c.433 0 .864.131 1.173.435A5 5 0 0 1 15 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
      fill="url(#cashback_svg__a)"
    />
    <defs>
      <radialGradient
        id="cashback_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-16.5 0 0 -13.2 17 12)"
      >
        <stop stopColor="#00CAC1" />
        <stop offset={0.344} stopColor="#13B8DC" />
        <stop offset={0.755} stopColor="#386CDE" />
        <stop offset={1} stopColor="#693CB8" />
      </radialGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgCashback);
export default Memo;
